import React, { useState, useEffect, useContext } from 'react';
import '../styles/SignIn.scss';
import logo from '../assets/images/logo.png';
import { useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../utils/axios';
import { ToastContainer, toast } from 'react-toastify';
import { AuthContext } from '../contexts/AuthContext';


const SignInPage = () => {
  const { login } = useContext(AuthContext);
  const [formData, setFormData] = useState({email: ''});
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    /* global google */
    const initializeGoogleSignIn = () => {
      if (!window.google) return;

      google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_AUTH_ID,
        callback: handleCredentialResponse,
      });
      // console.log("Google Client ID:", process.env.REACT_APP_GOOGLE_AUTH_ID);

      google.accounts.id.renderButton(
        document.getElementById("google-login-btn"),
        { theme: "outline", size: "large" }
      );
    };

    // Prevent duplicate script load
    if (!document.getElementById("google-client-script")) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.id = "google-client-script";
      script.onload = initializeGoogleSignIn;
      document.body.appendChild(script);
    } else {
      initializeGoogleSignIn();
    }
  }, []);

  const handleCredentialResponse = async (response) => {
    // console.log("Encoded JWT ID token:", response.credential);

    try {
      const res = await axiosInstance.post("accounts/google-login/", {
        id_token: response.credential,
      });
      const {access_token, refresh_token, name} = res.data;
      login(name, access_token, refresh_token);
      axiosInstance.defaults.headers['Authorization'] = `Bearer ${access_token}`;
      console.log("signin", location)
      const redirectTo = location.state?.from || "/";
      navigate(redirectTo, { state: { from: location.pathname, state: location.state } });
    } catch (error) {
      toast("Login Failed");
      console.error("Error sending token to backend:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Enter a valid email address';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validation = validateForm();

    if (Object.keys(validation).length > 0) {
      setErrors(validation);
      return;
    }
    setIsLoading(true);
    try {
      // console.log(formData.email)
      await axiosInstance.post("accounts/send-otp/", {'email': formData.email});
      toast("Please check the email for otp");
      console.log("send otp ==>")
      navigate(`/verify-otp/${formData.email}`, { state: { from: location.pathname, state: location.state } })
    } catch (err) {
      console.error(err);
      toast("Login Failed");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="signin-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">

            {/* Header */}
            <div className="signin-header">
              <div className="brand-logo">
                <img src={logo} alt="Logo" className="logo-icon" />
              </div>
              <p className="brand-subtitle">Welcome back to GETAM</p>
            </div>

            {/* Signin Card */}
            <div className="signin-card">
              <h2 className="signin-title h3">Sign In</h2>
                <div  style={{ textAlign: "center", marginBottom: "30px" }}>
                  <div className='google-sign-wrapper' id="google-login-btn"></div>
                </div>

              {/* Email */}
              {<div className="form-floating">
                <input
                  type="email"
                  className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                />
                <label htmlFor="email">Email</label>
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>}

              {/* Sign In Button */}
              {<button
                type="button"
                className="btn btn-primary-custom"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send OTP'}
              </button>}
            </div>

          </div>
        </div>
      </div>
      <ToastContainer/>
    </div>
  );
}
export default SignInPage;